import React from 'react';

import { useIntl } from 'react-intl';
import { di } from 'react-magnetic-di';

import { cssMap } from '@atlaskit/css';
import TimePicker from '@atlaskit/datetime-picker/time-picker';
import { Box } from '@atlaskit/primitives/compiled';

import { asFormLocalTimeField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';
import { messages } from './messages';

const styles = cssMap({
	container: {
		maxWidth: '160px',
	},
});

export const PreviewLocalTimeInput = ({
	fieldId,
	fieldInputId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);

	const intl = useIntl();

	const formField = useFormField({ fieldId });
	const formLocalTimeField = asFormLocalTimeField(formField);

	if (formLocalTimeField === undefined) {
		return <></>;
	}

	return (
		<Box xcss={styles.container}>
			<TimePicker
				id={fieldInputId}
				value={formLocalTimeField.value?.localTime}
				locale={intl.locale}
				testId="field-input-local-time-preview"
				isDisabled
				label={formField?.label || intl.formatMessage(messages.timeLabel)}
			/>
		</Box>
	);
};
